<div class="sub-header-layout">
  <!-- Opt-in via [showBreadcrumb]; only deeply-nested pages enable it. The trail
       itself comes from the routes' data.breadcrumb (WCAG 2.4.5). -->
  @if (showBreadcrumb()) {
    <cm-breadcrumb />
  }
  <div class="header-content">
    <div class="header-content__left">
      @if (hasBackButton()) {
        @if (customBackHandler()) {
          <button aut-id="btn-back" class="back-button" type="button" aria-label="Go back" (click)="backButtonClick.emit()">
            <cm-icon name="arrow_back" />
          </button>
        } @else {
          <a aut-id="link-back" class="back-button" routerLink="../" aria-label="Go back">
            <cm-icon name="arrow_back" />
          </a>
        }
      }

      <div class="header-title">
        @if (topTitle()) {
          <span class="header-top-title" [attr.aut-id]="topTitleAutId() || null">{{ topTitle() }}</span>
        }
        <div class="header-title-row" [class.chips-bottom]="chipsPosition() === 'bottom'" >
          <div class="header-title-heading">
            @if (iconTitle()) {
              <cm-icon
                [name]="iconTitle()"
                [color]="iconColor()"
                [size]="iconSize()"
                class="header-title-icon"
              />
            }
            <cm-heading [level]="titleLevel()" [visualLevel]="visualTitleLevel()">{{ title() }}</cm-heading>
          </div>
          @if (chips().length > 0 || subtitleChips().length > 0) {
            <div class="header-chips">
              @for (chip of chips(); track chip.label) {
                @if (chip.backgroundColor) {
                  <cm-chip
                    [backgroundColor]="chip.backgroundColor"
                    [textColor]="chip.textColor ?? '#ffffff'"
                    size="sm"
                    [attr.role]="chip.role ?? 'status'"
                    [attr.aria-label]="chip.ariaLabel"
                    [attr.aut-id]="chip.autId ?? null"
                  >
                    <span aria-hidden="true">{{ chip.label }}</span>
                    <span class="sr-only">{{ chip.ariaLabel }}</span>
                  </cm-chip>
                } @else {
                  <cm-chip
                    [color]="chip.color!"
                    size="sm"
                    [attr.role]="chip.role ?? 'status'"
                    [attr.aria-label]="chip.ariaLabel"
                    [attr.aut-id]="chip.autId ?? null"
                  >
                    <span aria-hidden="true">{{ chip.label }}</span>
                    <span class="sr-only">{{ chip.ariaLabel }}</span>
                  </cm-chip>
                }
              }
              @for (chip of subtitleChips(); track chip.label) {
                @if (chip.backgroundColor) {
                  <cm-chip
                    [backgroundColor]="chip.backgroundColor"
                    [textColor]="chip.textColor ?? '#ffffff'"
                    size="sm"
                    [attr.role]="chip.role ?? 'status'"
                    [attr.aria-label]="chip.ariaLabel"
                    [attr.aut-id]="chip.autId ?? null"
                  >
                    <span aria-hidden="true">{{ chip.label }}</span>
                    <span class="sr-only">{{ chip.ariaLabel }}</span>
                  </cm-chip>
                } @else {
                  <cm-chip
                    [color]="chip.color!"
                    size="sm"
                    [attr.role]="chip.role ?? 'status'"
                    [attr.aria-label]="chip.ariaLabel"
                    [attr.aut-id]="chip.autId ?? null"
                  >
                    <span aria-hidden="true">{{ chip.label }}</span>
                    <span class="sr-only">{{ chip.ariaLabel }}</span>
                  </cm-chip>
                }
              }
            </div>
          }
        </div>
        @if (subtitleHtml()) {
          <p class="header-description" [innerHTML]="safeSubtitleHtml"></p>
        } @else if (subtitle()) {
          <p class="header-description">{{ subtitle() }}</p>
        }
      </div>
    </div>
    <div class="header-content__right">
      <ng-content />
    </div>
  </div>
</div>
